import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import { ReportTemplate } from "../../../shared/reporting/api/biClient.types";
import { useClientContext } from "../../contexts/ClientContext";
import { selectCurrentReport } from "../../store/selectors/currentReportSelectors";
import { getOrganizationReportTemplatesUrl } from "../builder/common/utilities/editReportUrl";
import { getAdminPortalEditTemplateUrl } from "../builder/getAdminPortalReportUrls.ts";
import RedirectToAdminPortal from "../builder/RedirectToAdminPortal.tsx";

export default function EditTemplatePage() {
  const template = useSelector(selectCurrentReport) as ReportTemplate;
  const { clientInfo } = useClientContext();

  if (template === undefined) {
    return <Navigate to={getOrganizationReportTemplatesUrl(clientInfo.organization)} />;
  }

  return (
    <RedirectToAdminPortal
      url={getAdminPortalEditTemplateUrl(clientInfo.clientCode, clientInfo.organization, template.reportId)}
    />
  );
}
